import _styled from "styled-components";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18next from "i18next";
import { runInAction } from "mobx";
import { RawButton } from "../../Styled/Button";
import Text from "../../Styled/Text";
import CustomComponent from "./CustomComponent";
import parseCustomMarkdownToReact from "./parseCustomMarkdownToReact";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
function showFeedback(viewState) {
  runInAction(() => {
    viewState.feedbackFormIsVisible = true;
    viewState.terria.notificationState.dismissCurrentNotification();
  });
}
export const FeedbackLink = props =>
// If we have feedbackUrl = show button to open feedback dialog
props.viewState.terria.configParameters.feedbackUrl ? /*#__PURE__*/_jsx(_StyledRawButton, {
  fullWidth: true,
  onClick: () => showFeedback(props.viewState),
  children: /*#__PURE__*/_jsx(Text, {
    bold: true,
    isLink: true,
    children: parseCustomMarkdownToReact(props.feedbackMessage ? props.feedbackMessage : i18next.t("models.raiseError.notificationFeedback"))
  })
}) :
/*#__PURE__*/
// If we only have supportEmail - show message and the email address
_jsx(_Fragment, {
  children: parseCustomMarkdownToReact(props.emailMessage ? "".concat(props.emailMessage, " ").concat(props.viewState.terria.supportEmail) : i18next.t("models.raiseError.notificationFeedbackEmail", {
    email: props.viewState.terria.supportEmail
  }))
});

/**
 * A `<feedbacklink>` custom component, which displays a feedback button (if the feature is enabled), or an email address.
 */
export default class FeedbackLinkCustomComponent extends CustomComponent {
  get name() {
    return FeedbackLinkCustomComponent.componentName;
  }
  get attributes() {
    return ["email-message", "feedback-message"];
  }
  processNode(context, node, _children) {
    var _node$attribs, _node$attribs2;
    if (!context.viewState) return undefined;
    return /*#__PURE__*/_jsx(FeedbackLink, {
      viewState: context.viewState,
      emailMessage: (_node$attribs = node.attribs) === null || _node$attribs === void 0 ? void 0 : _node$attribs["email-message"],
      feedbackMessage: (_node$attribs2 = node.attribs) === null || _node$attribs2 === void 0 ? void 0 : _node$attribs2["feedback-message"]
    });
  }
}
_defineProperty(FeedbackLinkCustomComponent, "componentName", "feedbacklink");
var _StyledRawButton = _styled(RawButton).withConfig({
  displayName: "FeedbackLinkCustomComponent___StyledRawButton",
  componentId: "sc-zyi7s9-0"
})(["text-align:left;"]);